import InfoIcon from '@mui/icons-material/Info'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import React, { useState } from 'react'
import { RedirectUrls } from 'src/types/types'
import ModalDrawer from '../ModalDrawer'

function Policies() {
  const { t } = useTranslation('details')
  const { t: tCommon } = useTranslation('common')
  const [policiesOpen, setPoliciesOpen] = useState(false)

  return (
    <>
      <ModalDrawer
        isOpen={policiesOpen}
        setIsOpen={setPoliciesOpen}
        title={t('POLICIES.TITLE')}
      >
        <div className="flex flex-col gap-4 pb-6 text-sm leading-relaxed text-ink-200 md:text-base">
          <p>
            Para la seguridad y protección de nuestros anfitriones, SpotMe no
            permite vivir o trabajar dentro de los espacios de almacenamiento.
            Los anuncios en nuestra plataforma son únicamente para almacenar
            artículos.
          </p>
          <p>
            {`Permitir que un inquilino viva o trabaje en un espacio de almacenamiento anula protecciones importantes como la Garantía del Anfitrión o la Protección de Pagos, y va en contra de nuestros `}
            <Link
              href={RedirectUrls.TermsAndConditions}
              className="font-medium text-blue-800 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
            >
              Términos de Servicio
            </Link>
            .
          </p>
          <p>
            {`Si tienes alguna otra pregunta, consulta los `}
            <Link
              href={RedirectUrls.TermsAndConditions}
              className="font-medium text-blue-800 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
            >
              Términos de Servicio
            </Link>
            {` para saber cómo se puede usar un espacio de almacenamiento.`}
          </p>
        </div>
      </ModalDrawer>

      <section>
        <p className="font-display text-[11px] tracking-[0.22em] text-blue-500 uppercase md:text-xs">
          {t('POLICIES.TITLE')}
        </p>
        <div className="mt-3 flex items-baseline gap-2">
          <h2 className="font-display text-[20px] leading-tight font-medium text-ink-700 md:text-[24px]">
            No se permite vivir en el espacio
          </h2>
          <button
            type="button"
            onClick={() => setPoliciesOpen(true)}
            className="inline-flex size-5 items-center justify-center rounded-full text-ink-200 transition-colors hover:text-blue-500"
            aria-label={tCommon('A11Y.VIEW_POLICY_INFO')}
          >
            <InfoIcon sx={{ fontSize: 14 }} />
          </button>
        </div>
        <p className="mt-3 max-w-md text-[14px] leading-relaxed text-ink-200 md:text-[15px]">
          Los espacios SpotMe son únicamente para almacenar artículos.
        </p>
      </section>
    </>
  )
}

export default React.memo(Policies)
